import WithGASetup from '../../../components/WithGASetup';
import AuthContext from '../../../context/AuthContext.js';
import ResearcherDashboardPage from './ResearcherDashboardPage.js';

export default WithGASetup(ResearcherDashboardPage, AuthContext);
